import React, { useState } from 'react'
import { PatientHistoryType } from 'src/graphql.generated'
import { UploadedPatientFile } from '../../../../api/useUploadPatientFile'
import { useSubmitPatientHistory } from '../../../../api/useSubmitPatientHistory'
import {
  FieldGrid,
  FieldSection,
  FormActions,
  LabeledDate,
  LabeledText,
  todayIso,
  useRequiredFields,
} from '../../../fieldPrimitives'
import FileUploadField from '../FileUploadField'
import { ADVANCED_NOTE_KIND_FIELD } from '../advancedNoteKinds'

// `type` and `advancedNoteKind` decide only what gets stored, not what is shown.
const NoteFields = ({
  uid,
  type,
  advancedNoteKind,
}: {
  uid: string
  type: PatientHistoryType
  advancedNoteKind?: string
}) => {
  const [date, setDate] = useState(todayIso())
  const [description, setDescription] = useState('')
  const [files, setFiles] = useState<UploadedPatientFile[]>([])
  const { submit, submitting, error } = useSubmitPatientHistory(uid)
  const required = useRequiredFields({ 'Date of event': Boolean(date), Description: Boolean(description.trim()) })

  const onSubmit = async () => {
    if (!required.attempt()) {
      return
    }

    await submit({
      date,
      type,
      value: { description, ...(advancedNoteKind && { [ADVANCED_NOTE_KIND_FIELD]: advancedNoteKind }) },
      fileIDs: files.map((file) => file.fileID),
    })
    setDescription('')
    setFiles([])
    required.reset()
  }

  return (
    <FieldSection>
      <FieldGrid>
        <LabeledDate
          label="Date of event"
          value={date}
          onChange={setDate}
          required
          error={required.error('Date of event')}
        />
      </FieldGrid>
      <LabeledText
        label="Description"
        value={description}
        onChange={setDescription}
        multiline
        required
        error={required.error('Description')}
      />
      <FileUploadField uid={uid} files={files} onChange={setFiles} />
      <FormActions onSubmit={onSubmit} disabled={false} submitting={submitting} error={error} />
    </FieldSection>
  )
}

export default NoteFields
